<template>
  <div class="ssw">
    <div class="ssw-title">
      <div>搜数网</div>
      <p>事实研究型双语统计资料数据库</p>
    </div>

    <div>
      <img />
    </div>

    <div class="ssw-content">
      <p class="content-title">
        科研数据、市场方案书写时，寻找数据有困难吗？搜数网——中国和世界各国经济和社会统计数据垂直搜索网！通过全文检索或径索引方式，你能获取目标统计信息，并可以下载通用格式的统计表格。
      </p>
      <div class="content-wrap">
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw1.png" />
          <div class="item-wrap">
            <div class="item-title">全面的行业数据</div>
            <p class="item-introduce">
              涵盖所有热门行业，直观反应国民经济和社会发展状况，共涉及54个喊个，超过4.6亿条数据
            </p>
          </div>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw2.png" />
          <div class="item-wrap">
            <div class="item-title">人性化的表格预览功能</div>
            <p class="item-introduce">
              搜数网为所有用户提供预览付费表格文献,方便使用者了解除具体数字外的表格详细信息。
            </p>
          </div>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw3.png" />
          <div class="item-wrap">
            <div class="item-title">更广的区域数据</div>
            <p class="item-introduce">
              覆盖全国23个省、5个自治区、4个直辖市、2个特别行政区域。独家收录港澳台地区的统计年鉴,超过9800本年鉴、超过230万个表格、超过4亿6千万条数据。
            </p>
          </div>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw4.png" />
          <div class="item-wrap">
            <div class="item-title">灵活的数据导出工具</div>
            <p class="item-introduce">
              搜数网为授权用户提供电子表格(EXCEL)文件下载功能,为使用者灵活分析和处理数据提供方便。
            </p>
          </div>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw5.png" />
          <div class="item-wrap">
            <div class="item-title">双语实时更新</div>
            <p class="item-introduce">
              20年不间断数据,每日更新,让应用者不论对最新数据的使用还是20年内数字的攫取研究都能得心应手。英文版面所有表格接入SOSHOO主板,可查看中文对照表格。界面清晰简明,检索方便友善。
            </p>
          </div>
        </div>
        <div class="item">
          <img class="item-img" src="@/assets/image/ico_ssw6.png" />
          <div class="item-wrap">
            <div class="item-title">强大的搜索功能</div>
            <p class="item-introduce">
              提供简易和专业检索方式,“简易检索”只需在检索框输入关键词即可。在“专业检索”功能下,你可以定义检索关键词组及关键词之间的逻辑关系,还可以对行业、地区、时间等项目进行选择。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.ssw-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_ssw.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }
}
.ssw-content {
  width: 80%;
  margin: 64px auto;
  .content-title {
    margin: 0 0 64px;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .content-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      display: flex;
      align-items: flex-start;
      width: 46%;
      min-height: 200px;
      margin: 24px 0;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 16px 0px #cfd8eb;
      .item-img {
        width: 80px;
        height: 80px;
        margin: 24px;
      }
      .item-wrap {
        margin: 24px;
        .item-title {
          font-size: 24px;
          font-weight: 500;
          text-align: left;
          color: #333333;
        }
        .item-introduce {
          margin: 16px 0;
          font-size: 16px;
          text-align: left;
          color: #656565;
          line-height: 28px;
        }
      }
    }
  }
}
</style>
